import { CommonRegionBehaviorConfig } from "../common/region-config.js";

export class ParticleEffectsRegionBehaviorConfig extends CommonRegionBehaviorConfig {
  static FIELDSET_LEGEND_I18N = "FXMASTER.Regions.BehaviorNames.ParticleEffectRegionBehaviorName";
}

export class SuppressSceneParticlesRegionBehaviorConfig extends CommonRegionBehaviorConfig {
  static FIELDSET_LEGEND_I18N = "FXMASTER.Regions.BehaviorNames.SuppressSceneParticlesRegionBehaviorName";
}
